export { default } from './PerformersTaskInputs';



// WEBPACK FOOTER //
// ./src/components/Tasks/TaskFrom/PerformersTaskInputs/index.js